import { Component, EnvironmentInjector, Input, NgZone, OnInit, ViewChild, runInInjectionContext } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { IonModal } from '@ionic/angular/standalone';
import { IonicComponentsModule } from 'src/app/modules/ionic-components.module';
import { ComboboxWithStoreComponent } from '../combobox-with-store/combobox-with-store.component';
import InfiniteScrollSubject from 'src/app/subjects/infiniteScrollSubject';
import DefectoClass from 'src/app/model/api/inspecciones/defectoClass';
import { BehaviorSubject, Subscription, defer } from 'rxjs';
import Paging from 'src/app/model/api/generic/paging';
import { UtilService } from 'src/app/services/util.service';
import { TextinputComponent } from '../textinput/textinput.component';
import { RadiogroupComponent } from '../radiogroup/radiogroup.component';
import ValoracionClass from 'src/app/model/api/inspecciones/valoracionClass';
import { DatabaseService } from 'src/app/database/database.service';
import { TextAreaComponent } from '../text-area/text-area.component';

@Component({
  selector: 'app-defectos',
  templateUrl: './defectos.component.html',
  styleUrls: ['./defectos.component.scss'],
  standalone: true,
  imports: [
    IonicComponentsModule,
    ComboboxWithStoreComponent,
    TextAreaComponent
  ]
})
export class DefectosComponent {

  //#region Propiedades

  private _form: AbstractControl<any, any>
  // El formGroup del parámetro, donde dentro tendremos el formArray de los defectos
  @Input("form") public set form(value: AbstractControl<any, any>) {
    this._form = value as FormGroup
  }
  public get form(): FormGroup {
    return this._form as FormGroup
  }
  @ViewChild("modal") public modal: IonModal
  private defectosStore: InfiniteScrollSubject<DefectoClass> = null
  private valoracionesStore: BehaviorSubject<ValoracionClass[]> = null
  public modalGroup = this.fb.group({
    DefectoSeleccionado: [null as number]
  })
  private defectoSubscription: Subscription

  //#endregion

  //#region Constructor

  constructor(
    private injector: EnvironmentInjector,
    private fb: FormBuilder,
    private util: UtilService,
    private database: DatabaseService
  ) { 
    console.log('se construye control de defectos')
    this.defectoSubscription = this.modalGroup.valueChanges.subscribe(async (value) => {
      if (value?.DefectoSeleccionado != null) {

        // Obtenemos el defecto del maestro
        let defectosMaestro = this.form.get('DefectosMaestro')?.value as DefectoClass[]
        let defectoMaestro = defectosMaestro.find(p => p.Id == value.DefectoSeleccionado)

        if (defectoMaestro != null) {

          // Creamos el defecto
          let defecto = this.fb.group({
            Codigo: [''],
            Defecto: [''],
            Id: [0],
            Observaciones: [''],
            ValoracionId: [''],
            Valoracion: [''],
            DefectoId: [0]
          })
          defecto.patchValue({
            Codigo: defectoMaestro.Codigo,
            Defecto: defectoMaestro.Defecto,
            Id: 0,
            Observaciones: '',
            ValoracionId: defectoMaestro.ValoracionId,
            Valoracion: defectoMaestro.Valoracion,
            DefectoId: 0
          });

          let defectosEstablecidos = this.form.get('DefectosEstablecidos') as FormArray
          defectosEstablecidos.push(defecto)
          defectosEstablecidos.updateValueAndValidity()
                    
        }

        await this.util.Sleep(1)
        this.modalGroup.setValue({
          DefectoSeleccionado: null
        })

      }
    })
  }

  ngOnDestroy(): void {
    this.defectoSubscription.unsubscribe()
  }

  //#endregion

  //#region Modal

  public async show(): Promise<void> {
    this.modal.isOpen = true
  }

  public async onDismiss(): Promise<void> {
    this.modal.isOpen = false
  }

  //#endregion

  //#region Maestro defectos

  public get listaDefectosMaestro(): FormArray {
    return this.form.get('DefectosMaestro') as FormArray
  }

  public get defectosEstablecidos(): FormArray {
    return this.form.get('DefectosEstablecidos') as FormArray
  }

  public EliminarDefecto(control: AbstractControl<any, any>): void {
    let formArray = this.form.get('DefectosEstablecidos') as FormArray
    formArray.controls = formArray.controls.filter(p => p != control)
    formArray.updateValueAndValidity()
  }

  public GetDefectosStore(): InfiniteScrollSubject<DefectoClass> {
    if (this.defectosStore != null) return this.defectosStore
    this.defectosStore = runInInjectionContext(this.injector, () => {
      return new InfiniteScrollSubject<DefectoClass>(
        (requestObj) => defer(async() => {
          let formArray = this.form.get('DefectosMaestro') as FormArray
          let items = formArray?.value as DefectoClass[]
          let result = new Paging<DefectoClass>()
          result.collection = items
          console.log(this.form.getRawValue())

          // Filtramos para seleccionar únicamente los defectos en base al valor del campo.
          let tiposDefecto = this.form.get('Valor')?.value?.split(';').filter(p => p != null && p != '') // Ids de los valores del parámetro.
          let tiposValues: ('MG' | 'G' | 'L' | 'ALL')[] = [] // Obtenemos los tipos (MG = Muy grave, G = Grave, L = Leve)
          for (let tipo of tiposDefecto) {
            if (tipo.toString().toLowerCase() == 'false') continue;
            if (tipo.toString().toLowerCase() == 'true') {
              tiposValues.push('ALL')
              continue;
            }
            let valor = await this.database.Valores.getById(parseInt(tipo))
            // Como nos viene un valor de tipo "DG (2002)" nos quedamos con la primera palabra para obtener el tipo (DG, DMG, DL, etc)
            if (valor.Valor?.toUpperCase() == 'SI' || valor.Valor?.toUpperCase() == 'SÍ' || valor.Valor?.toUpperCase() == 'NO') {
              tiposValues.push('ALL')
            } else {
              if (valor.Valor?.indexOf('M') != -1) {
                tiposValues.push('MG')
              } else if (valor.Valor?.indexOf('G') != -1) {
                tiposValues.push('G')
              } else if (valor.Valor?.indexOf('L') != -1) {
                tiposValues.push('L')
              }
            }
          }

          // Establecemos el string de las valoraciones
          let valoraciones = await this.database.Valoraciones.getAll()
          result.collection.forEach(p => {
            p.Valoracion = valoraciones.find(q => q.Id == p.ValoracionId)?.Codigo || ''
          })
          const valoracionEsTipo = (valoracion: string, tipo: 'MG' | 'G' | 'L' | 'ALL') => {
            if (tipo == 'ALL') return true
            if (tipo == 'MG' && valoracion.indexOf('M') != -1) {
              return true
            } else if (tipo == 'G' && valoracion.indexOf('G') != -1 && valoracion.indexOf('MG') == -1) {
              return true
            } else if (tipo == 'L' && valoracion.indexOf('L') != -1) {
              return true
            }
            return false
          }
          result.collection = result.collection.filter(p => tiposValues.some(q => valoracionEsTipo(p.Valoracion, q)))

          // Filtro de búsqueda
          if (requestObj.search != null && requestObj.search != '') {
            result.collection = result.collection.filter(p => `${p.Valoracion} - ${p.Defecto}`.toLowerCase().indexOf(requestObj.search?.toLowerCase()) != -1)
          }

          let totalPages = Math.ceil(result.collection.length / requestObj.limit)
          let page = (requestObj.start / requestObj.limit) + 1
          let total = result.collection.length
          result.collection = result.collection.slice(requestObj.start, requestObj.start + requestObj.limit)

          result.count = result.collection.length
          result.page = page
          result.total = total
          result.totalPages = totalPages

          return result
        }),
        Number.MAX_VALUE,
        (Id) => defer(async() => {
          if (Id == null || isNaN(parseInt(Id))) return null
          let formArray = this.form.get('DefectosMaestro') as FormArray
          let items = formArray?.value as DefectoClass[]
          let item = items.find(p => p.Id == Id)
          return item
        })
      )
    })
    return this.defectosStore
  }

  public GetValoracionesStore(): BehaviorSubject<ValoracionClass[]> {
    if (this.valoracionesStore != null) return this.valoracionesStore
    this.valoracionesStore = new BehaviorSubject<ValoracionClass[]>([])
    this.database.Valoraciones.getAll().then(valoraciones => {
      this.valoracionesStore.next(valoraciones)
    })
    return this.valoracionesStore
  }

  public GetValoracion(valoracionId: string, valoraciones: ValoracionClass[]) {
    return valoraciones.find(p => p.Id == valoracionId)?.Codigo || ''
  }

  //#endregion

}
